import { Tab, Tabs } from "@mui/material";
import { useState } from "react";
import { TabPanel } from "../../App/Components/TabGroup/TabGroup";
import { useGroupProfileContext } from "../State/GroupProfileContext";
import EmailAnalytics from "./Tabs/EmailAnalytics";
import GroupCandidateListing from "./Tabs/GroupCandidateListing";
import TextAnalytics from "./Tabs/TextAnalytics";

function getGroupTablePanelProps(index: number) {
  return {
    id: `group-table-tab-${index}`,
    "aria-controls": `group-table-tabpanel-${index}`,
  };
}

export default function GroupTableTabs() {
  const { group } = useGroupProfileContext();
  const [tabValue, setTabValue] = useState(0);
  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  return (
    <>
      <Tabs
        value={tabValue}
        onChange={handleChange}
        aria-label="Group Table Tabs"
        sx={{ width: "auto", borderBottom: 1, borderColor: "divider", mb: 3 }}
      >
        <Tab data-test="group-candidates-tab" label="Candidates" {...getGroupTablePanelProps(0)} />
        <Tab data-test="group-email-tab" label="Email Analytics" {...getGroupTablePanelProps(1)} />
        <Tab data-test="group-sms-tab" label="SMS Analytics" {...getGroupTablePanelProps(2)} />
      </Tabs>
      <TabPanel data-test="group-candidates-tab-panel" value={tabValue} index={0}>
        <GroupCandidateListing isTableVisible={tabValue === 0} />
      </TabPanel>
      <TabPanel data-test="group-email-tab-panel" value={tabValue} index={1}>
        <EmailAnalytics groupId={group.id} />
      </TabPanel>
      <TabPanel data-test="group-sms-tab-panel" value={tabValue} index={2}>
        <TextAnalytics groupId={group.id} />
      </TabPanel>
    </>
  );
}
